import ManageAgents from './ManageAgents'

export default ManageAgents
